import type { AccountPlatformType } from "../../../../shared/types/accounts";
import { INSTAGRAM_AND_FACEBOOK } from "../components/PlatformLabelBadges/PlatformLabelBadges";

/** The channels a story can go to (IDEA-622). */
const STORY_PLATFORM_TYPES: AccountPlatformType[] = ["IG", "FB"];

/** Every selected channel can take a story, so the Story switch may turn on. */
export const canPostAsStory = (
  platforms: { TYPE: string }[] | undefined
): boolean => {
  const allowed: string[] = STORY_PLATFORM_TYPES;

  return (
    !!platforms &&
    platforms.length > 0 &&
    platforms.every((platform) => allowed.includes(platform.TYPE))
  );
};

/**
 * A customised channel blocks a story only when `platformFields` is passed,
 * because a story is post-wide.
 */
export const useStoryCapability = (
  platforms: { TYPE: string }[] | undefined,
  {
    platformFields,
  }: {
    platformFields?: Partial<Record<string, { unlinked?: boolean }>>;
  } = {}
) => {
  const channelsCanPost = canPostAsStory(platforms);
  const hasCustomisedChannel =
    !!platformFields &&
    !!platforms?.some(
      (platform) => platformFields[platform.TYPE]?.unlinked === true
    );

  let unavailableReason: string | null = null;
  if (!channelsCanPost) {
    unavailableReason =
      "To post a story or send a notification, keep only Instagram and Facebook channels.";
  } else if (hasCustomisedChannel) {
    unavailableReason =
      "To post a story, turn off Customise on each channel. A story uses the same content on every channel.";
  }

  return {
    platformTypes: STORY_PLATFORM_TYPES,
    canPost: channelsCanPost && !hasCustomisedChannel,
    label: "Switch to Story",
    unavailableLabel: "Why Story is unavailable",
    badges: INSTAGRAM_AND_FACEBOOK,
    unavailableReason,
  };
};
